import type { UserOfficeAffiliation } from "le-coffre-resources/dist/Notary";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import type { ActiveOfficeStoreLoadSyncTarget } from "./activeOfficeStoreLoadAndSync";
import { loadUserOfficesFromDatabase } from "./activeOfficeStoreLoadAndSync";

export async function applyIdNotSyncedAffiliations(
	store: ActiveOfficeStoreLoadSyncTarget,
	userUid: string,
	affiliations: UserOfficeAffiliation[],
): Promise<void> {
	if (affiliations.length === 0) {
		LoggerService.warn("⚠️ Synchronisation IdNot n'a retourné aucun office, rechargement depuis la base");
		await loadUserOfficesFromDatabase(store, userUid);
		return;
	}
	const hasMissingOfficeData = affiliations.some((affiliation) => !affiliation.office || !affiliation.office.name);
	if (hasMissingOfficeData) {
		LoggerService.warn("⚠️ Synchronisation IdNot : informations office incomplètes, rechargement depuis la base");
		await loadUserOfficesFromDatabase(store, userUid);
		return;
	}
	store.availableOffices = [...affiliations];
	const primary = affiliations.find((a) => a.is_primary);
	if (primary) {
		store.activeOffice = primary;
	}
}
